import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

function NotFoundPage() {
  return (
    <div className={styles.container}>
      <div className={styles.code}>404</div>
      <p className={styles.message}>
        Oops! This page got lost in the paint. Let's head back to the gallery.
      </p>
      <Link to="/" className={styles.homeLink}>Back to Gallery</Link>
    </div>
  );
}

export default NotFoundPage;
